import { render, staticRenderFns } from "./OnsiteDisposalPlan.vue?vue&type=template&id=d08ff818&scoped=true"
import script from "./OnsiteDisposalPlan.vue?vue&type=script&lang=js"
export * from "./OnsiteDisposalPlan.vue?vue&type=script&lang=js"
import style0 from "./OnsiteDisposalPlan.vue?vue&type=style&index=0&id=d08ff818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08ff818",
  null
  
)

export default component.exports